import * as React from 'react';
import { NextPage } from 'next';
import { Forgot } from '@/components/Forgot';
import { Layout } from '@/components/Layout/';
import { AMPLITUDE_PAGES } from '@/modules/amplitude/events';

const Page: NextPage = () => (
	<Layout pageName={AMPLITUDE_PAGES.FORGOT_PAGE}>
		<Forgot />
	</Layout>
);

export default Page;
